import { Injectable } from "@angular/core";
import { UrlConnectionEnum } from "../../enums/url-connection.enum";
import { HttpService } from "../http-service/http.service";

@Injectable({
    providedIn: 'root'
})
export class LoginService {

    constructor(private httpService: HttpService) { }

    /**
     * Pre login
     * @author Starley Cazorla
     * @param email
     * @returns
     */
    preLogin(email: string) {
        return new Promise((resolve, reject) => {
            const config = this.httpService.setHeaderConfig(false);

            this.httpService.post(UrlConnectionEnum.GET_TOKEN, { email: email }, config).subscribe({
                next: (res) => {
                    resolve(res);
                },
                error: (err) => {
                    reject(err);
                }
            });
        });
    }

    /**
     * Logins login service
     * @author Starley Cazorla
     * @param email
     * @param token
     * @returns
     */
    login(email: string, token: string) {
        return new Promise((resolve, reject) => {
            const config = this.httpService.setHeaderConfig(false);

            this.httpService.post(UrlConnectionEnum.LOGIN, { email: email, token: token }, config).subscribe({
                next: (res) => {
                    resolve(res);
                },
                error: (err) => {
                    reject(err);
                }
            });
        });
    }

}
